import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zbx7a6ctts: FaireBrandEntity = {
  token: "b_zbx7a6ctts",
  type: "brand",
  name: "Date Better Snacks",
  avatarUrl:
    "https://cdn.faire.com/fastly/edd804c34df801b9cd0f72889142648605858327fd5e17f9b474f99cdaf38647.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6651e8d93ada4870fee68fbd051aef73283993b94a9cb00d2ae97a267f957912.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/edd804c34df801b9cd0f72889142648605858327fd5e17f9b474f99cdaf38647.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6651e8d93ada4870fee68fbd051aef73283993b94a9cb00d2ae97a267f957912.jpeg",
  location: "91207, CA, USA",
  minimumOrderDollars: 72,
  rating: 4.9,
  reviewCount: 102,
  isTopShop: true,
  isInsider: true,
  description:
    "Michelle Valdez Wilton created a snack that is nutritious and wholesome yet still indulgent. Dates don't normally have the reputation of being fun, so I wanted to create a product that would change that perception.\nThe dates are stuffed with delicious nut butters and enrobed in organic fair trade chocolate that does not contain any preservatives and/or emulsifiers. All of our flavors are vegan and gluten-free.  With less than 1g of added sugar, why wouldn't you Date Better? ",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:47.704Z",
    importedBy: "entity-db-cli",
  },
};
